// API URL
// export const API_URL = "https://api.hrzyra.com";
// export const API_URL = "https://uatapi.hrzyra.com";
export const API_URL = "https://qaapi.hrzyra.com";

// local server
// export const API_URL = "http://192.168.0.28:8000";
// export const API_URL = "http://localhost:1212/";

/** Join API_URL to a path with exactly one slash between them.
 *  API_URL is edited by hand per environment and may or may not end in "/",
 *  while every path constant here starts without one. Hand-built URLs that
 *  assume either way produce "//path", which Django answers with a 404 HTML
 *  page rather than the endpoint. */
export const apiUrlFor = (path = "") =>
  `${API_URL.replace(/\/+$/, "")}/${String(path).replace(/^\/+/, "")}`;

/** WebSocket URL for real-time notifications (derived from API_URL). */
export const getNotificationWsUrl = () => {
  const token = sessionStorage.getItem("token") || "";
  const wsBase = API_URL.replace(/^http/i, "ws").replace(/\/+$/, "");
  return `${wsBase}/ws/notifications/?token=${encodeURIComponent(token)}`;
};

// authentication endpoints
export const LOGIN_URL = `/authentication/login/`;
export const SESSION_REFRESH_URL = `/authentication/session/`;
export const LOGOUT_URL = `/authentication/logout/`;
export const FORGOT_PASSWORD = `/authentication/forgotpassword/`; // not found in hrbuddie endpoints
export const CHANGE_PASSWORD = `/authentication/changepassword/`;
export const SEND_OTP = `/authentication/send_otp/`;
export const VERIFY_OTP = `/authentication/verify_otp/`;

// home screen endpoints
export const HOME = `home/`;
export const HAPPYMETER = `home/happy_meter/`;
export const CLOCKIFY = `home/clockify/`;
export const NOTIFICATION = `home/notification/`;
export const NOTIFICATION_COUNT = `home/notification/count/`;
export const NOTIFICATION_MARK_READ = `home/notification/mark-read/`;
export const NOTIFICATION_LOG = `home/notification/log/`;
export const ADMIN_DASHBOARD = `home/admin_dashboard/`;
export const ADMIN_DASHBOARD_PRESENCE_LIST = `home/admin_dashboard/presence_list/`;
// Org-admin Dashboard Overview: one row per branch (org admin only). Answers
// "which branch needs me", where ADMIN_DASHBOARD answers "what's due today" for
// a single branch.
export const ORG_DASHBOARD = `home/org_dashboard/`;

export const ATTENDANCE_DASHBOARD = `attendance/dashboard/`;
export const NEW_EMPLOYEE_ATTENDANCE_DAILY = `attendance/`;
export const NEW_EMPLOYEE_ATTENDANCE_LOG = `attendance/attendance_log/`;
export const NEW_EMPLOYEE_ATTENDANCE_CORRECTION_REQUEST = `attendance/correction-request/`;
export const ATTENDANCE_CORRECTION_HISTORY = `attendance/correction-history/`;
export const PUNCH_DISCREPANCIES = `attendance/punch-discrepancies/`;
export const EMPLOYEE_MY_PENALTIES = `attendance/my-penalties/`;
export const PENALTY_APPEAL = `attendance/penalty-appeal/`;
export const SHIFT_CHANGE_REQUEST = `attendance/shift-change-request/`;

export const USERGROUP = 'administrator/user_group/'
export const USERPERMISSION = 'administrator/user_permissions/'
export const PASSWORD_POLICY = 'administrator/password_policy/'
export const NOTICE_BOARD = 'administrator/notice_board/'
export const EMPLOYER = 'administrator/company/';
export const COMPANY_ADD = 'administrator/company/add/';
export const ORGANIZATION_DOCUMENTS = 'administrator/documents'
// Branch management.
export const BRANCH = 'administrator/branches/';
// Branch transfer requests (create / list / approve) + the lightweight
// branch-scoped employee dropdown and per-request approval history.
export const BRANCH_TRANSFER = 'employee/branch_transfer/';
export const TRANSFER_REPORTING_MANAGER = 'employee/transfer_reporting_manager/';
export const TRANSFER_REPORTING_MANAGER_INBOX = 'employee/transfer_reporting_manager_inbox/';
// Per-person branch access (branch + role + delegated CRUD grants), managed
// from the User Permission page. GET ?employee_id= reads current access;
// PUT applies changes (validated server-side against the actor's own role).
export const BRANCH_ACCESS = 'employee/branch_access/';

// master
export const EMPLOYEE_TYPE = `master/employee_type/`;
export const EMPLOYEE_DEPARTMENT = `master/departments/`;
export const EMPLOYEE_DESIGNATION = `master/designation/`;
export const EMPLOYEE_GROUP = `master/group/`;
export const EMPLOYEE_LEAVE_POLICY = `master/leave_type/`;
export const REIMBURSEMENTS_CONFIG = `master/reimbursement_type/`;
export const ASSET_MANAGEMENT = `master/asset_type/`;
export const MASTER_ASSET_CATEGORY = `master/asset_category/`;
export const MASTER_ASSET_SUBCATEGORY = `master/asset_sub_category/`;
export const LETTER_TYPE_API = `master/letter_type/`;
export const LETTER_TEMPLATE_API = `master/letter_template/`;
export const MASTER_CITY = `master/city/`;
export const MASTER_BLOCK = `master/block/`;
export const MASTER_FLOOR = `master/floor/`;
export const MASTER_ROOM = `master/room/`;
export const MASTER_DOCUMENT_TYPE = `master/document_type/`;

// configuration
export const EMPLOYEE_SHIFT = 'configuration/shift/'
export const DEPARTMENT_ALLOWED_SHIFTS = 'configuration/department_allowed_shifts/'
export const SHIFT_HEADCOUNT_REPORT = 'reports/shift_headcount/'
export const HOLIDAY_SETUP = 'configuration/holiday/'
export const EMPLOYEE_WEEK_OFF = 'configuration/weekoff/'
export const PAYROLL_PERIOD = 'configuration/payroll_period/'
export const SALARY_COMPONENT = 'configuration/salary_component/'
export const SALARY_TEMPLATE = 'configuration/salary_template/'
export const CUSTOM_CONFIGURATION = 'configuration/custom_configuration/'
export const SUBORDINATE_SETUP = 'configuration/subordinate/'
export const SUBORDINATE_CARDS = 'configuration/cards/'
// Dearness Allowance revision register. All three share the 'da_revision'
// permission on the backend because they are one screen: the register, the
// per-employee impact preview, and the apply action that writes the revised
// salary versions.
export const DA_REVISION = 'configuration/da_revision/'
export const DA_REVISION_PREVIEW = 'configuration/da_revision/preview/'
export const DA_REVISION_APPLY = 'configuration/da_revision/apply/'

// employee
export const EMPLOYEE_PERSONAL_INFO = `employee/info/`;
export const EMPLOYEE_OCCUPANCY = `employee/occupancy/`;
export const EMPLOYEE_PROFILE = `employee/profile/`; // logged-in user's own profile (GET) + photo update (POST)
export const EMPLOYEEDOC = `employee/document/`;
export const EMPLOYEESAL = `employee/salary/`;
export const EMPLOYEEISSUEDDOC = `employee/document/issued/`;
export const EMPLOYEE_QUALIFICATION_DOC = `employee/document/qualification/`;
export const EMPLOYEE_CONFIRM_PERMANENT = `employee/document/qualification/confirm-permanent/`;
export const EMPLOYEE_REMARKS = `employee/remarks/`;
export const EMPLOYEE_ALLOWANCES = `employee/allowances/`;
export const EMPLOYEE_DEDUCTIONS = `employee/deductions/`;
// Employee deposits: money the organisation holds and owes back. The register
// returns each deposit with its ledger totals; ?id= adds the full statement.
// Both share the 'employee_deposits' permission.
export const EMPLOYEE_DEPOSITS = `employee/deposits/`;
export const EMPLOYEE_DEPOSITS_SUMMARY = `employee/deposits/summary/`;
export const EMPLOYEE_ACTIVITY = `employee/activity/`;
export const EMPLOYEE_AUDIT = `employee/audit/`;

export const EMPLOYEE_CANDIDATE_INFO = `employee/candidate/info/`;
export const EMPLOYEE_CANDIDATE_DOC = `employee/candidate/document/`
export const EMPLOYEE_CANDIDATE_SAL = `employee/candidate/salary/`
export const EMPLOYEE_CANDIDATE_ISSUEDDOC = ``; // --> this concept is skipped and handled in final stage of verification
export const EMPLOYEE_CANDIDATE_VERIFICATION = `employee/candidate/verification/`;
export const EMPLOYEE_CANDIDATE_OFFER_LETTER = `employee/offer_letter/`

export const EMPLOYEE_INTERN_INFO = `employee/interns/info/`;
export const EMPLOYEE_INTERN_DOC = `employee/interns/document/`
export const EMPLOYEE_INTERN_SAL = `employee/interns/salary/`
export const EMPLOYEE_INTERN_ISSUEDDOC = ``;  // --> this concept is skipped and handled in final stage of verification
export const EMPLOYEE_INTERN_VERIFICATION = `employee/interns/verification/`;
export const EMPLOYEE_INTERN_OFFER_LETTER = `employee/offer_letter/`

// employee request endpoints
export const LEAVE_URL = `employee/leave_request/`;
export const REIMBURSEMENT_URL = `employee/reimbursement_request/`;
export const OVERTIME_URL = `employee/overtime_request/`;
export const ADVANCE_URL = `employee/advance_salary_request/`;
export const SUBORDINATES_URL = `employee/subordinates/employee_list/`;
export const SUBORDINATE_ATTENDANCE_SUMMARY_URL = `employee/subordinates/attendance_list/`;
export const RESIGNATION_URL = `employee/resignation_request/`;
export const RESIGNATION_APPROVER_URL = `employee/resignation_approver/`;
export const RESIGNATION_PROCESS_URL = `employee/resignation_process/`;
export const ABSCONDING_URL = `employee/absconding/`;

// day-end tasks (My Tasks / Team Tasks — URLs keep /timesheet for compatibility)
export const TIMESHEET_URL = `employee/timesheet/`;
export const TEAM_TIMESHEET_URL = `employee/team/timesheet/`;
export const TEAM_TIMESHEET_SUMMARY_URL = `employee/team/timesheet/summary/`;
export const TEAM_TIMESHEET_NOT_SUBMITTED_URL = `employee/team/timesheet/not-submitted/`;

// approval inbox
export const LEAVE_REQUEST_URL = 'employee/leave_approval/'
export const REIMBURESMENT_REQUEST_URL = 'employee/reimbursement_approval/'
export const ADVANCE_REQUEST_URL = 'employee/advance_salary_approval/'
export const OVERTIME_APPROVAL_URL = 'employee/overtime_approval/'
export const RESIGNATION_REQUEST_URL = 'employee/resignation_approval/'

// payroll
export const PAYROLL_PROCESS = `payroll/payroll_process/`;
export const PAYROLL_RUN_GET = `payroll/run_payroll/`;
export const PAYROLL_RECALCULATE = `payroll/recalculate_payroll/`;
export const PAYROLL_SHORT_DUTY_REVIEW = `payroll/short_duty_review/`;
export const PAYROLL_HOLD = `payroll/payroll_hold/`;
export const PAYROLL_ATTENDANCE_PENALTIES = `payroll/attendance_penalties/`;
export const PAYROLL_TDS_SLAB = `payroll/tds_slab/`;
export const PAYROLL_TDS_PREVIEW = `payroll/tds_preview/`;

// Perk eligibility: the criteria register, the rule vocabulary the editor is
// built from, the read-only preview, the evaluation that stores a shortlist, and
// the reviewer's include/exclude decisions. All five share the 'perk_criteria'
// permission because they are one screen.
export const PERK_CRITERIA = `payroll/perk_criteria/`;
export const PERK_VOCABULARY = `payroll/perk_criteria/vocabulary/`;
export const PERK_PREVIEW = `payroll/perk_criteria/preview/`;
export const PERK_EVALUATE = `payroll/perk_criteria/evaluate/`;
export const PERK_CANDIDATES = `payroll/perk_criteria/candidates/`;
// GET downloads the fixed-column template; POST uploads the filled-in copy and
// returns the parsed criteria plus any problems. The upload writes nothing —
// creating still goes through PERK_CRITERIA, so a sheet cannot bypass the same
// validation the on-screen editor runs.
export const PERK_SHEET = `payroll/perk_criteria/sheet/`;
// The money side. Preview costs nothing and writes nothing; generating creates
// pending payouts that the next payroll run credits as a payslip line. Shares the
// 'perk_criteria' permission — paying a shortlist is the same privilege as
// deciding it.
export const PERK_PAYOUT = `payroll/perk_payout/`;
export const PERK_PAYOUT_PREVIEW = `payroll/perk_payout/preview/`;
export const PAYROLL_ADVANCE_EMI_SKIP = `payroll/advance_emi_skip/`;
export const PAYROLL_PAYSLIP_EDIT = `/payroll/salary_edit/`
export const PAYROLL_PUBLISH = `payroll/publish_payslip/`;
export const PAYROLL_BANK_ADVICE = `payroll/bank_advice/`;
export const PAYROLL_PAY_SLIP = `payroll/payslip/`;
export const PAYROLL_PAYSLIP_PRINT = `payroll/payslip/print/`;

// attendance
export const DAYWISE_ATTENDANCE = 'attendance'
export const MONTHWISE_ATTENDANCE_LOG = 'attendance/attendance_log/'
export const ATTENDANCE_LOG_CHART = 'attendance/attendance_log/chart/'
export const EMPLOYEE_ATTENDANCE_DAILY = 'attendance/'
export const EMPLOYEE_MISSING_ATTENDANCE_CORRECTION = 'attendance/correction-request/'

// assets
export const ASSET_REGISTRY = `asset_management/asset_registry/`;
export const ASSET_EMPLOYEE_AUDIT = `asset_management/employee_audit/`;
// asset requests / tickets (employee raises, admin approves & issues)
export const ASSET_REQUEST = `asset_management/asset_request/`;
//asset registry city - floor - block - room 
export const ASSET_CITY = `asset_management/asset_city/`;
export const ASSET_BLOCK = `asset_management/asset_block/`;
export const ASSET_FLOOR = `asset_management/asset_floor/`;
export const ASSET_ROOM = `asset_management/asset_room/`;

// roster
export const ROSTERING_GET = `rostering/`;
export const INDIVIDUAL_ROSTERING_GET = `rostering/rostering_rotational_shift/`;
// Shifts read/written from the organization & employee hierarchy screens.
export const HIERARCHY_SHIFT = `rostering/hierarchy_shift/`;
// The spreadsheet-style planning grid. PUT takes changed cells only, and
// validate_only turns the same call into the import preview.
export const DUTY_ROSTER = `rostering/duty_roster/`;
// Shift changes are split across two modules on purpose. Raising one lives
// under employee/ because IsAuthenticated short-circuits that module for every
// employee; a plain employee would get a 403 on a rostering/ URL before an admin
// ticked a permission box. Approving stays on the gated rostering endpoint, so
// revoking "Shift Change Request" from a user group really does remove it.
// "Yesterday's assignment is still pending" — the on-screen counterpart of the
// daily notification, scoped to the caller's own team.
export const PENDING_SHIFT_ALERTS = `rostering/pending_shift_alerts/`;
export const MY_SHIFT_CHANGE = `employee/shift_change/`;
export const SHIFT_CHANGE_APPROVAL = `rostering/shift_change_request/`;

// reports
export const DAYWISE_ATTENDANCE_REPORTS = 'reports/attendance/day/'
export const MONTHWISE_ATTENDANCE_REPORTS = 'reports/attendance/month/'
export const DETAILED_ATTENDANCE_REPORT = 'reports/attendance/detailed/'
export const DISCREPANCY_REPORT = 'reports/discrepancy/'
export const PERMISSION_PUNCH_REPORT = 'reports/permission_punch/'
export const SALARY_CORRECTION_QUEUE = 'payroll/salary_correction_queue/'
export const SALARYPROCESS_BANK_REPORTS = 'reports/bank/'
export const SALARYSUMMARY_REPORTS = 'reports/salary_summary/'
export const PAYROLL_DETAIL_REPORTS = 'reports/payroll/'
export const EMPLOYEE_ESI_REPORTS = 'reports/esi/'
export const EMPLOYEE_PF_REPORTS = 'reports/pf/'
export const MUSTER_ROLL_REPORT = 'reports/muster_roll/'
export const EMPLOYEE_CREDIT_DEBIT = 'reports/credit_debit/'
export const EMPLOYEE_ATTENDANCE_CORRECTION = 'reports/attendance/correction/'
export const SUBORDINATES_REPORTS = 'reports/subordinates/'
export const ROSTERING_REPORT = 'reports/roster_report/'
export const LEAVE_PERMISSION_REPORT = 'reports/approved_leaves_report/'
export const SHORT_DUTY_REPORT = 'reports/short_duty/'
export const FINE_REPORT = 'reports/fine_report/'
export const BRANCH_WISE_ACTIVITY_REPORT = 'reports/branch_wise_activity/'
export const DEPARTMENT_WISE_ACTIVITY_REPORT = 'reports/department_wise_activity/'
export const DOCUMENT_UPLOAD_REPORT = 'reports/document_upload/'

// data migration (employee bulk import)
export const EMPLOYEE_MIGRATION_LIST = `data_migration/employee_migration/list/`;
export const EMPLOYEE_MIGRATION_TEMPLATE = `data_migration/employee_migration/template/`;
export const EMPLOYEE_MIGRATION_PROCESS = `data_migration/employee_migration/migrate/`;
export const EMPLOYEE_MIGRATION_REPORTING_MANAGER = `data_migration/employee_migration/reporting_manager/`;
export const EMPLOYEE_MIGRATION_SALARY_COLUMNS = `data_migration/employee_migration/salary_columns/`;

// data migration (master bulk import)
export const MASTER_MIGRATION_LIST = `data_migration/master_migration/list/`;
export const MASTER_MIGRATION_TEMPLATE = `data_migration/master_migration/template/`;
export const MASTER_MIGRATION_PROCESS = `data_migration/master_migration/migrate/`;
export const MASTER_BUNDLE_LIST = `data_migration/master_bundle/list/`;
export const MASTER_BUNDLE_TEMPLATE = `data_migration/master_bundle/template/`;
export const MASTER_BUNDLE_PROCESS = `data_migration/master_bundle/migrate/`;

// settings
export const SETTINGS_CHANGE_PASSWORD = 'employee/password/change/'

// calendar
export const CALENDAR_EVENTS = 'calendar/events/';

// ERP Integration
export const ERP_CONNECTION_STATUS = 'erp/connection/status/';
export const ERP_CONNECTION_GENERATE = '/erp/connection/generate/';
export const ERP_CONNECTION_REVOKE = '/erp/connection/revoke/';

// eMedHub (HIMS) integration — connection config + doctor sync/mapping
export const INTEGRATION_CONNECTION = 'integrations/connection/';
export const INTEGRATION_SYNC = 'integrations/sync/';
export const INTEGRATION_CONFIRM_LINK = 'integrations/sync/confirm-link/';
export const INTEGRATION_DOCTORS = 'integrations/doctors/';
export const INTEGRATION_EMPLOYEES = 'integrations/employees/';
export const INTEGRATION_MAPPINGS = 'integrations/mappings/';
export const INTEGRATION_MAPPINGS_BULK = 'integrations/mappings/bulk/';
export const INTEGRATION_DOCTOR_SHARE_DETAIL = 'integrations/doctor-share-detail/';

// training
export const TRAINING_TASKS = 'training/tasks/';
export const TRAINING_OVERVIEW = 'training/tasks/overview/';
export const TRAINING_MY_TASKS = 'training/my-tasks/';
export const TRAINING_MY_TASK_STATUS = 'training/my-tasks/status/';
export const TRAINING_ASSIGNMENT = 'training/assignments/';
export const TRAINING_TEAM_TASKS = 'training/team-tasks/';
export const TRAINING_VERIFY = 'training/assignments/verify/';
export const TRAINING_AUDIT = 'training/assignments/audit/';
export const TRAINING_MATERIALS = 'training/materials/';
export const TRAINING_EVIDENCE = 'training/evidence/';

// internship programs
export const INTERNSHIP_PROGRAMS = 'internship/programs/';
export const INTERNSHIP_PHASES = 'internship/phases/';
export const INTERNSHIP_ENROLMENTS = 'internship/enrolments/';
export const INTERNSHIP_PROGRESS = 'internship/enrolments/progress/';
export const INTERNSHIP_CERTIFICATE = 'internship/certificate/';
export const MY_INTERNSHIP = 'internship/my-internship/';

// appraisal
export const APPRAISAL_CYCLES = 'appraisal/cycles/';
export const APPRAISAL_KPI_METRICS = 'appraisal/kpi-metrics/';
export const APPRAISALS = 'appraisal/appraisals/';

// Biometric device administration
export const BIOMETRIC_DEVICE_CONFIG = 'biometric/device/config/';
export const BIOMETRIC_EMPLOYEE_MAPPING = 'biometric/employees/mapping/';
export const BIOMETRIC_MAPPED_EMPLOYEES = 'biometric/employees/mapping/list/';
export const APPRAISAL_AUDIT = 'appraisal/appraisals/audit/';
export const APPRAISAL_ACKNOWLEDGE = 'appraisal/appraisals/acknowledge/';
export const APPRAISAL_SUBMIT = 'appraisal/appraisals/submit/';
export const APPRAISAL_RM_REVIEW = 'appraisal/appraisals/rm-review/';
export const APPRAISAL_HR_REVIEW = 'appraisal/appraisals/hr-review/';
export const APPRAISAL_PUBLISH = 'appraisal/appraisals/publish/';
export const APPRAISAL_ATTACHMENTS = 'appraisal/attachments/';
export const APPRAISAL_REVIEWERS = 'appraisal/reviewers/';
export const APPRAISAL_FEEDBACK = 'appraisal/feedback/';
export const APPRAISAL_AGREE_GOALS = 'appraisal/appraisals/agree-goals/';
export const APPRAISAL_CHECK_INS = 'appraisal/check-ins/';
export const APPRAISAL_REVISE_GOALS = 'appraisal/appraisals/revise-goals/';
export const APPRAISAL_DEVELOPMENT_ACTIONS = 'appraisal/development-actions/';
export const APPRAISAL_DEVELOPMENT_CARRY_FORWARD = 'appraisal/development-actions/carry-forward/';
export const APPRAISAL_CALIBRATION_SESSIONS = 'appraisal/calibration/sessions/';
export const APPRAISAL_CALIBRATION_ADJUSTMENTS = 'appraisal/calibration/adjustments/';
export const APPRAISAL_NINE_BOX = 'appraisal/nine-box/';
export const APPRAISAL_COMPETENCIES = 'appraisal/competencies/';
export const APPRAISAL_COMPETENCY_FRAMEWORKS = 'appraisal/competency-frameworks/';
export const APPRAISAL_COMPETENCY_RATINGS = 'appraisal/competency-ratings/';

// ai copilot
// AI_CHAT is both the ask endpoint (POST) and the session list (GET).
export const AI_CHAT = 'ai/chat/';
export const AI_CHAT_HISTORY = 'ai/chat/history/';
export const AI_FEEDBACK = 'ai/feedback/';
export const AI_CONTEXT = 'ai/context/';
// grievance / complaint management
export const GRIEVANCE_CATEGORIES = 'grievance/categories/';
export const GRIEVANCES = 'grievance/grievances/';
export const GRIEVANCE_AUDIT = 'grievance/grievances/audit/';
export const GRIEVANCE_RESPOND = 'grievance/grievances/respond/';
export const GRIEVANCE_WITHDRAW = 'grievance/grievances/withdraw/';
export const GRIEVANCE_CLOSE = 'grievance/grievances/close/';
export const GRIEVANCE_REOPEN = 'grievance/grievances/reopen/';
export const GRIEVANCE_ACKNOWLEDGE = 'grievance/grievances/acknowledge/';
export const GRIEVANCE_ASSIGN = 'grievance/grievances/assign/';
export const GRIEVANCE_INVESTIGATE = 'grievance/grievances/investigate/';
export const GRIEVANCE_REQUEST_INFO = 'grievance/grievances/request-info/';
export const GRIEVANCE_ESCALATE = 'grievance/grievances/escalate/';
export const GRIEVANCE_RESOLVE = 'grievance/grievances/resolve/';
export const GRIEVANCE_COMMENTS = 'grievance/comments/';
export const GRIEVANCE_ATTACHMENTS = 'grievance/attachments/';
export const GRIEVANCE_ATTACHMENT_DOWNLOAD = 'grievance/attachments/download/';
export const GRIEVANCE_DASHBOARD = 'grievance/dashboard/';
